import React, { useState } from 'react'
import type { DatePickerProps } from 'antd'
import { DatePicker, ConfigProvider } from 'antd'
import idataCodingStylesDark from '../../pages/common/global-styles/idatacoding-dark.module.less'
import idataCodingStyles from '../../pages/common/global-styles/idatacoding.module.less'
import type { RangePickerProps } from 'antd/es/date-picker'
import { SwapRightOutlined } from '@ant-design/icons'
import zhCN from 'antd/lib/locale/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'
export interface Props {
  mode: string
  startDate?: any
  setStartDate?: any
  endDate?: any
  setEndDate?: any
  onEndDateChange?: any
  onStartDateChange?: any
}
moment.locale('zh-cn')

const DateRangePicker: React.FC<Props> = (props) => {
  const { startDate, endDate, onStartDateChange, onEndDateChange } = props
  const { mode } = props
  // const [startDate, setStartDate] = useState("" as null | string)
  // const [endDate, setEndDate] = useState("" as null | string)

  // const onStartDateChange: DatePickerProps['onChange'] = (date, dateString) => {
  //   setStartDate(dateString)
  //   actionCallback && actionCallback()
  // }

  // const onEndDateChange: DatePickerProps['onChange'] = (date, dateString) => {
  //   setEndDate(dateString)
  //   actionCallback && actionCallback()
  // }

  const disabledStartDate: RangePickerProps['disabledDate'] = (current) => {
    if (endDate !== '' && endDate) {
      return (
        current &&
        (current > moment(endDate).endOf('day') ||
          current > moment().endOf('day'))
      )
    } else {
      return current && current > moment().endOf('day')
    }
  }

  const disabledEndDate: RangePickerProps['disabledDate'] = (current) => {
    if (
      startDate !== '' &&
      startDate &&
      new Date(startDate).toLocaleDateString() !==
        new Date().toLocaleDateString()
    ) {
      return current > moment().endOf('day')
    } else {
      return current && current > moment().endOf('day')
    }
  }
  return (
    <div style={{ position: 'relative' }}>
      <ConfigProvider locale={zhCN}>
        <DatePicker
          getPopupContainer={(trigger: HTMLElement): HTMLElement =>
            trigger.parentElement ? trigger.parentElement : trigger
          }
          placeholder="起始日期"
          format="YYYY/MM/DD"
          style={
               { backgroundColor: '#fff' }
          }
          className={
         idataCodingStyles.datePicker
          }
          onChange={onStartDateChange.bind(this)}
          disabledDate={disabledStartDate}
        />
      </ConfigProvider>
      <SwapRightOutlined />
      <ConfigProvider locale={zhCN}>
        <DatePicker
          getPopupContainer={(trigger: HTMLElement): HTMLElement =>
            trigger.parentElement ? trigger.parentElement : trigger
          }
          placeholder="结束日期"
          format="YYYY/MM/DD"
          style={
            mode === 'oam'
              ? { backgroundColor: '#fff' }
              : { backgroundColor: '#fff' }
          }
          className={
            mode === 'oam'
              ? idataCodingStyles.datePicker
              : idataCodingStyles.datePicker
          }
          onChange={onEndDateChange.bind(this)}
          disabledDate={disabledEndDate}
        />
      </ConfigProvider>
    </div>
  )
}

export default DateRangePicker
